import useAppContext from 'flow/hooks/useAppContext';

const TranscriptionEmpty = () => {
    const { i18next } = useAppContext();

    return (
        <div className="flex flex-1 items-center justify-center text-base text-gray-500">
            {i18next.t('ai.transcript.no_transcript_found')}
        </div>
    );
};

export default TranscriptionEmpty;
